import { useGetMember } from '#api/member';
import { useScheduleCoachDetailQuery } from '#hooks/queries/schedules/useScheduleCoachDetailQuery';
import { useDashboardChartFormProcess } from '#pages/DashboardChartForm/hooks/useDashboardChartFormProcess';
import { Suspense } from 'react';
import { Panel } from 'src/shared/components/panel';
import { MemberInfoForm } from './MemberInfoForm';
import { MemberInfoList } from './MemberInfoList';

export const MemberInfo = () => {
  const { searchQuery } = useDashboardChartFormProcess();
  const { registeredLectureId } = searchQuery;

  const { data: coachSchedule } = useScheduleCoachDetailQuery(
    {
      id: registeredLectureId as string
    },
    {
      enabled: !!registeredLectureId
    }
  );

  const personId = coachSchedule?.personId;
  const { data: memberInfo } = useGetMember(personId || '', {
    enabled: !!personId
  });

  if (!memberInfo) return null;

  const hasMemberInfo = !!memberInfo.jobId;

  return (
    <div className="flex flex-col gap-16">
      <div className="text-[#d7d2de] text-lg font-medium font-['Pretendard Variable']">
        회원 정보
      </div>
      <Panel isOpen={!hasMemberInfo} title={'사전 정보'} required>
        {hasMemberInfo ? (
          <MemberInfoList memberInfo={memberInfo} />
        ) : (
          <Suspense fallback={<div></div>}>
            <MemberInfoForm />
          </Suspense>
        )}
      </Panel>
    </div>
  );
};
